import React from 'react';
import WidgetReference from './WidgetReference';

export default function AMOE() {
  return (
    <>
      <WidgetReference guideId="amoe" />
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Alternative_method_of_entry_AMOE_In_Shopify__T4wSKHGuShag0BqN5p-4Aw"
      height="640"
      title="Alternative Method of Entry (AMOE)"
      allowFullScreen
    />
    </>
  );
}
